// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const feebas: PokeData = {
  "id": 349,
  "name": "feebas",
  "height": 6,
  "weight": 74,
  "base_experience": 40,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "tackle",
    "splash",
    "flail"
  ],
  "moves": [
    "tackle",
    "splash",
    "bubble-beam",
    "aqua-cutter",
    "rain-dance",
    "water-spout",
    "whirlpool",
    "hydro-pump",
    "liquidation",
    "aqua-tail",
    "brine",
    "bubble",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 178,
    "item": null,
    "species": [
      {
        "name": "feebas",
        "order": 377,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "milotic",
        "order": 378,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 349,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": 170,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 28.75,
    "speed": 80,
    "ability_power": 15
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
